var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`type-block bg-color-ptype-${_vm.type.toLowerCase()}`},[_vm._v(" "+_vm._s(_vm.getTypeName(_vm.type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }